export const FREE_TEXT_MIN_FONT_SIZE = 8;
export const FREE_TEXT_MAX_FONT_SIZE = 72;
export const FREE_TEXT_DEFAULT_FONT_SIZE = 16;
export const FREE_TEXT_MIN_TEXT_BOX_WIDTH = 40;
export const FREE_TEXT_MAX_TEXT_BOX_WIDTH = 1200;
export const FREE_TEXT_MIN_TEXT_BOX_HEIGHT = 40;
export const FREE_TEXT_MAX_TEXT_BOX_HEIGHT = 1200;

export enum FloorplanFreeTextListType {
  NONE = "NONE",
  BULLET = "BULLET",
  NUMBERED = "NUMBERED",
}
